module.exports = __webpack_public_path__ + "img/occupied.b9b35233.svg";